import { z } from "zod";

const envSchema = z.object({
  VITE_API_BASE: z.string().default("/api"),
  VITE_DEFAULT_LOCALE: z.string().default("zh-CN"),
  VITE_APP_VERSION: z.string().default("1.0.0"),
  VITE_EXTENSION_ID: z.string().optional(),
  VITE_EXTENSION_INSTALL_URL: z
    .string()
    .url()
    .default("https://help.withpinbox.com/how-to.html"),
  MODE: z.string().default("production"),
});

const parsed = envSchema.parse(import.meta.env ?? {});

/**
 * 类型安全的环境变量访问入口。
 * 所有环境变量统一从此处读取，禁止在业务代码中直接使用 `import.meta.env`。
 */
export const ENV = {
  /** API 基础路径 */
  apiBase: parsed.VITE_API_BASE,
  /** 默认语言 */
  defaultLocale: parsed.VITE_DEFAULT_LOCALE,
  /** 应用版本号 */
  appVersion: parsed.VITE_APP_VERSION,
  /** Chrome 扩展 ID（可选） */
  extensionId: parsed.VITE_EXTENSION_ID,
  /** 浏览器扩展安装地址 */
  extensionInstallUrl: parsed.VITE_EXTENSION_INSTALL_URL,
  /** Vite 运行模式 */
  mode: parsed.MODE,
  /** 是否为开发模式 */
  isDev: parsed.MODE === "development",
  /** 是否为生产模式 */
  isProd: parsed.MODE === "production",
} as const;
